/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * @author Satyaki Bose
 * @file SettingsSelectDropdownIcon.jsx
 */

import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icons/Icon';

const SettingsSelectDropdownIcon = ({ className, ...props }) => (
  <span {...props} className={className} style={{ marginRight: 8 }}>
    <Icon name="DropdownCaretDownIcon" style={{ fontSize: 12, width: 10, height: 6 }} />
  </span>
);

SettingsSelectDropdownIcon.propTypes = {
  className: PropTypes.string
};

SettingsSelectDropdownIcon.defaultProps = {
  className: ''
};

export default SettingsSelectDropdownIcon;
